export type SceneConfig = {
  mlVersion: string;
  maxSkippableTaks: number;
  customIntro?: boolean;
};

export type EquipmentConfig = {
  equipment: Equipment[];
  guidances: Guidance[];
};

export type PreparationConfig = {
  image: string;
  guidances: Guidance[];
};

export type Equipment = { name: string; image: string; count: number };

export type Guidance = {
  name: string;
  video: string;
  orientation: 'landscape' | 'portrait';
};
